module.exports = __webpack_public_path__ + "img/logo-digital-school.b15a37ca.png";